/* ============================================================
   YAVA LABS COLOMBIA — JS del tema
   Sin dependencias externas. Todo se degrada con gracia.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Barra de anuncios rotativa ---------- */
  function initAnnounce() {
    document.querySelectorAll('[data-announce]').forEach(function (bar) {
      var items = bar.querySelectorAll('.announce__item');
      if (items.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.dataset.speed, 10) || 4000;
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, speed);
    });
  }

  /* ---------- Menú móvil ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Bloque de oferta: compra única / suscripción ---------- */
  function initOffer() {
    document.querySelectorAll('[data-offer]').forEach(function (offer) {
      var buttons = offer.querySelectorAll('[data-mode]');
      var note = offer.querySelector('[data-offer-note]');
      if (!buttons.length) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.dataset.mode;
          buttons.forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');

          // Precios mostrados
          offer.querySelectorAll('[data-price-once]').forEach(function (el) {
            var v = mode === 'sub' ? el.dataset.priceSub : el.dataset.priceOnce;
            if (v) el.textContent = v;
          });

          // Plan de venta que se envía al carrito
          offer.querySelectorAll('[data-selling-plan-input]').forEach(function (input) {
            input.value = mode === 'sub' ? (input.dataset.planId || '') : '';
          });

          if (note) {
            note.textContent = mode === 'sub'
              ? (note.dataset.sub || '')
              : (note.dataset.once || '');
          }
        });
      });
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initSticky() {
    var sticky = document.querySelector('[data-sticky-cta]');
    if (!sticky) return;
    document.body.classList.add('has-sticky-cta');
    var target = document.querySelector('#oferta');
    var threshold = parseInt(sticky.dataset.threshold, 10) || 620;

    function update() {
      var hideOverTarget = false;
      if (target) {
        var r = target.getBoundingClientRect();
        hideOverTarget = r.top < window.innerHeight * 0.75 && r.bottom > 0;
      }
      if (window.scrollY > threshold && !hideOverTarget) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Cantidad en la página de producto ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'down' ? -1 : 1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    });
  }

  /* ---------- Selector de variantes ---------- */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-variant-price]');
      var compareEl = document.querySelector('[data-variant-compare]');
      var submit = form.querySelector('[data-add-to-cart]');
      var codBtn = form.querySelector('[data-cod-btn]');
      var data = {};
      try { data = JSON.parse(picker.dataset.variants || '{}'); } catch (e) { return; }

      picker.addEventListener('change', function () {
        var v = data[picker.value];
        if (!v) return;
        if (idInput) idInput.value = picker.value;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          compareEl.textContent = v.compare || '';
          compareEl.style.display = v.compare ? '' : 'none';
        }
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? (submit.dataset.labelAvailable || 'Agregar al carrito') : (submit.dataset.labelSoldout || 'Agotado');
        }
        if (codBtn) {
          codBtn.disabled = !v.available;
          codBtn.textContent = v.available ? (codBtn.dataset.labelAvailable || 'Pagar al recibir') : (codBtn.dataset.labelSoldout || 'Agotado');
        }
      });
    });
  }

  /* ---------- Pagar al recibir (Releasit) ----------
     Releasit solo escucha las clases _rsi-cod-form-*-overwrite en páginas de GemPages/PageFly,
     así que el clic se reenvía a su botón, que queda oculto dentro del formulario (ver theme.css). */
  function initCodButton() {
    document.querySelectorAll('.product__btn-cod[data-cod-btn]').forEach(function (btn) {
      if (btn._codBound) return;
      btn._codBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = btn.closest('form');
        var tries = 0;
        (function open() {
          var rsi = (form && form.querySelector('#rsi_buy_now_button')) || document.querySelector('#rsi_buy_now_button');
          if (rsi) rsi.click();
          else if (tries++ < 15) setTimeout(open, 200); // Releasit aún no ha cargado
        })();
      });
    });
  }

  /* ---------- Pagar al recibir desde las landings ----------
     Fuera de la ficha de producto Releasit no pone botón, así que el combo se agrega al carrito
     y /cart?cod=1 abre el formulario de Releasit del carrito, que crea el pedido en Shopify. */
  window.yavaCodToCart = function (variantId, properties) {
    var item = { id: Number(variantId), quantity: 1 };
    if (properties && Object.keys(properties).length) item.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/add ' + res.status);
      window.location.href = '/cart?cod=1';
    });
  };

  function initCartCod() {
    if (!/(^|[?&])cod=1(&|$)/.test(location.search.slice(1)) || !/\/cart\/?$/.test(location.pathname)) return;
    history.replaceState(null, '', location.pathname);
    // El botón de Releasit aparece antes de que responda al clic: se reintenta hasta que el formulario esté abierto.
    var tries = 0;
    (function open() {
      var form = document.querySelector('#rsi_form_wrapper');
      if (form && form.getBoundingClientRect().height > 0) return;
      var rsi = document.querySelector('#rsi_buy_now_button');
      if (rsi) rsi.click();
      if (tries++ < 15) setTimeout(open, 800);
    })();
  }

  /* ---------- Miniaturas de producto ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.full;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-on'); });
        thumb.classList.add('is-on');
      });
    });
  }

  function init() {
    initAnnounce();
    initMenu();
    initOffer();
    initSticky();
    initQty();
    initVariants();
    initCodButton();
    initCartCod();
    initGallery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Recargar comportamientos al editar en el personalizador de Shopify
  document.addEventListener('shopify:section:load', init);
})();
